module.exports = __webpack_public_path__ + "static/media/default-avatar.4e00595d.png";